import { Stack, Typography } from '@razz-team/ui-web';
import { useTranslation } from 'react-i18next';
import { AuthLayout } from '../AuthPage/AuthLayout';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <AuthLayout>
      <Stack>
        <Typography variant="body1">{t('Not found')}</Typography>
      </Stack>
    </AuthLayout>
  );
}
